import React, { useEffect, useState } from "react";
// import "./Category.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getProductCategoryByCategoryIdAPI,
  getProductCategoryDetailsAPI,
  productCategoryAssignmentAPI,
} from "../../../Store/Action/productCategory";
import CategoryCard from "../CustomComponents/CategoryCard";
import Header from "../Layout/Header/Header";
import CustomLoader from "../CustomComponents/CustomLoader/CustomLoader";

const AllCategories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  //Get Navigation state
  const fromShopByCategory = location?.state?.fromShopByCategory;
  const fromNosePinCollection = location?.state?.fromNosePinCollection;
  const fromRingCollection = location?.state?.fromRingCollection;
  const fromBrands = location?.state?.fromBrands;
  const fromMetalCategory = location?.state?.metalName;
  const fromShopByMetal = location?.state?.fromShopByMetal;
  const passedCategoriesData = location?.state?.categoriesData;

  useEffect(() => {
    // Fetch all categories or specific subcategories based on navigation state
    setIsLoading(true);
    
    if (fromNosePinCollection) {
      dispatch(
        getProductCategoryByCategoryIdAPI(
          location?.state?.nosePinCollectionData?.[0]?.product_category_id,
          (result) => {
            if (result?.status) {
              setAllSubCategories(result?.data?.[0]?.product_sub_category);
            }
            setIsLoading(false);
          },
        ),
      );
    } else if (fromRingCollection) {
      dispatch(
        getProductCategoryByCategoryIdAPI(
          location?.state?.ringCollectionData?.[0].product_category_id,
          (result) => {
            if (result?.status) {
              setAllSubCategories(result?.data?.[0]?.product_sub_category);
            }
            setIsLoading(false);
          },
        ),
      );
    } else if (fromBrands) {
      const params = {
        user_id: location?.state?.brand?.user_id,
      };

      dispatch(
        productCategoryAssignmentAPI(params, (result) => {
          setAllSubCategories(result?.data);
        }),
      );
      setIsLoading(false);
    } else if (fromMetalCategory && passedCategoriesData) {
      setAllCategories(passedCategoriesData);
      setIsLoading(false);
    } else {
      dispatch(
        getProductCategoryDetailsAPI({}, (result) => {
          if (result?.status) {
            setAllCategories(result.data);
          }
          setIsLoading(false);
        }),
      );
    }
  }, [dispatch, fromNosePinCollection, fromRingCollection, fromBrands]);

  // Function to handle category/subcategory clicks
  const handleIndividualCategory = async (category) => {
    setIsLoading(true);
    try {
      // If the view is from "Shop By Category," fetch subcategories
      if (fromShopByCategory) {
        await dispatch(
          getProductCategoryByCategoryIdAPI(
            category?.product_category_id,
            (result) => {
              if (result?.status) {
                const fetchedData = result?.data[0];
                const fetchedSubCategories =
                  fetchedData?.product_sub_categories;
                if (fetchedSubCategories.length > 0) {
                  navigate("/sub-categories", {
                    state: {
                      subCategories: fetchedSubCategories,
                      fromShopByCategoryViewAllPage: true,
                    },
                  });
                } else {
                  navigate(
                    `/productsList/${fetchedData?.product_category_id}`,
                    {
                      state: {
                        subCategoryId: fetchedData?.product_category_id,
                        subCategoryName: fetchedData?.product_category_name,
                      },
                    },
                  );
                }
              }
            },
          ),
        );
      } else if (fromBrands) {
        await dispatch(
          productCategoryAssignmentAPI(
            {
              product_category_id: category?.product_category_id,
              manufacturer_id: location?.state?.brand?.user_id,
            },
            (result) => {
              if (result?.status) {
                const fetchedData = result?.data[0];
                const fetchedSubCategories =
                  fetchedData?.product_sub_categories;

                if (fetchedSubCategories.length > 0) {
                  navigate("/sub-categories", {
                    state: {
                      subCategories: fetchedSubCategories,
                      manufacturerId: location?.state?.brand?.user_id,
                    },
                  });
                } else {
                  navigate(
                    `/productsList/${fetchedData?.product_category_id}`,
                    {
                      state: {
                        subCategoryId: fetchedData?.product_category_id,
                        subCategoryName: fetchedData?.product_category_name,
                        manufacturerId: location?.state?.brand?.manufacturer_id,
                      },
                    },
                  );
                }
              }
            },
          ),
        );
      } else {
        // Otherwise, navigate directly to the product list
        const { product_category_id, product_category_name } = category;
        navigate(`/productsList/${product_category_id}`, {
          state: {
            subCategoryId: product_category_id,
            subCategoryName: product_category_name,
            manufacturerId: location?.state?.brand?.manufacturer_id,
          },
        });
      }
    } catch (error) {
      console.log("Error handling category:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="shopByCategoryDiv">
        <div className="upperContent">
          <h1>
            {fromBrands
              ? `${location?.state?.brand?.user_shop_name + " " + "Collection"}`
              : fromShopByCategory
                ? "Shop By Category"
                : fromShopByMetal
                  ? `Shop By ${fromMetalCategory}`
                  : fromNosePinCollection
                    ? "Nose pin Collection"
                    : fromRingCollection
                      ? "Rings Collection"
                      : "Categories"}
          </h1>
          <p>Explore a wide range of categories to find your perfect match.</p>
        </div>
        <div className="lowerContent">
          <div className="hrLine" />

          {isLoading ? (
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          ) : fromBrands ? (
            <div className="cardsContainer">
              {allSubCategories?.map((subCategory, index) => (
                <CategoryCard
                  key={index}
                  item={{
                    image: `${subCategory?.product_category_storage_url}`,
                    name: subCategory.product_category_name,
                  }}
                  onClick={() => handleIndividualCategory(subCategory)}
                />
              ))}
            </div>
          ) : fromNosePinCollection || fromRingCollection ? (
            allSubCategories?.length > 0 ? (
              <div className="cardsContainer">
                {allSubCategories?.map((subCategory, index) => (
                  <CategoryCard
                    key={index}
                    item={{
                      image: `${subCategory?.product_category_storage_url}`,
                      name: subCategory.product_category_name,
                    }}
                    onClick={() => handleIndividualCategory(subCategory)}
                  />
                ))}
              </div>
            ) : (
              <p>No subcategories available</p>
            )
          ) : allCategories?.length > 0 ? (
            <div className="cardsContainer">
              {allCategories?.map((category, index) => (
                <CategoryCard
                  key={index}
                  item={{
                    image: `${category?.product_category_storage_url}`,
                    name: category?.product_category_name,
                  }}
                  onClick={() => handleIndividualCategory(category)}
                />
              ))}
            </div>
          ) : (
            <p>No categories available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default AllCategories;
